import React from "react";

const DockRightSingleColumn = ({ style = {} }) => {
    return (
        <svg id="dock-right" xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" style={style}>
            <path
                id="dock-right-2"
                data-name="dock-right"
                d="M20,4H4A2,2,0,0,0,2,6V18a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2M15,18H4V6H15Z"
                transform="translate(-2 -4)"
                fill="#fff"
            />
        </svg>
    );
};

export default DockRightSingleColumn;
